import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { History, Wallet, Home, Book, User } from "lucide-react";
import { isAppWebView } from "../utils/appWebView";

function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("user"));
  const inAppWebView = isAppWebView();

  const tabs = [
    { name: "Bids", path: "/bids", icon: History },
    { name: "Wallet", path: "/wallet", icon: Wallet },
    { name: "Home", path: "/dashboard", icon: Home },
    { name: "Passbook", path: "/passbook", icon: Book },
    { name: "Profile", path: "/profile", icon: User },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-amber-50 border-t border-amber-200/80 z-30 shadow-[0_-6px_20px_rgba(146,64,14,0.08)]">
      <div className={`flex items-center h-16 mx-auto ${inAppWebView ? "w-full max-w-none px-1" : "max-w-lg lg:max-w-5xl"}`}>
        {tabs.map((tab) => {
          const active = location.pathname === tab.path;
          const Icon = tab.icon;

          return (
            <button
              key={tab.name}
              onClick={() => navigate(tab.name === "Home" || user ? tab.path : "/login")}
              className="flex-1 flex flex-col items-center justify-center relative overflow-hidden active:bg-amber-100/70 transition-colors"
            >
              <div
                className={`flex items-center justify-center w-16 h-8 rounded-full ${
                  active ? "bg-amber-200/80" : "bg-transparent"
                }`}
              >
                <Icon
                  size={22}
                  className={
                    active ? "text-amber-700" : "text-gray-500"
                  }
                />
              </div>

              <span
                className={`text-[11px] mt-1 ${
                  active ? "text-amber-700 font-bold" : "text-gray-500 font-medium"
                }`}
              >
                {tab.name}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default BottomNav;
